module.exports = __webpack_public_path__ + "img/hr-rock-huge-05.b1fa49f4.png";